import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BiSolidRocket } from "react-icons/bi";

import { useAppDispatch } from "../../app/hook";
import { handleToggleShowUpgradePlanModal } from "../../features/ui/uiSlice";

interface IProBadge
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  className?: string;
  onClose?: () => void;
  variant?: "small" | "large";
  filled?: boolean;
  icon?: React.ReactNode;
}

const ProBadge = ({ variant = "large", icon, filled }: IProBadge) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  if (variant === "small")
    return (
      <div
        className={`tw-cursor-pointer ${
          !icon ? "tw-bg-amber-500" : ""
        } tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-full tw-border-none tw-p-1 tw-z-[2]`}
        onClick={() => dispatch(handleToggleShowUpgradePlanModal(true))}
      >
        {icon ? icon : <BiSolidRocket className="tw-text-white" />}
      </div>
    );

  return (
    <OverlayTrigger
      placement="auto"
      overlay={
        <Tooltip style={{ position: "fixed" }} id="tooltip">
          {t("Wizard/general/key12")}
        </Tooltip>
      }
    >
      <button
        onClick={() => dispatch(handleToggleShowUpgradePlanModal(true))}
        className={`tw-p-0.5 tw-m-1  tw-relative tw-z-[2] tw-w-[100px] tw-inline-flex tw-cursor-pointer tw-border-solid tw-pl-1 tw-pr-2 tw-py-1 tw-transition-colors ${
          filled
            ? "tw-bg-amber-500 tw-border-amber-500 tw-text-white"
            : "hover:tw-bg-amber-500 tw-border-amber-500 tw-bg-transparent [&>*]:tw-text-amber-500 [&>*]:hover:tw-text-white"
        }  tw-rounded-[20px] tw-border-2 tw-justify-center tw-items-center tw-gap-1`}
        type="button"
      >
        <BiSolidRocket className="tw-w-[40px] tw-flex-1 tw-h-3 tw-relative" />
        <div className="tw-text-xs tw-font-medium tw-font-['Lexend'] tw-leading-3">
          {t("DashboardUpgrade/key1")}
        </div>
      </button>
    </OverlayTrigger>
  );
};

export default ProBadge;
